export enum LanderQuizQuestionTypeEnum {
  SingleOptionButtons = "singleOptionButtons",
  FreeInput = "freeInput",
  DropDown = "dropDown",
  MultiOptionList = "multiOptionList",
  MultiOptionGrid = "multiOptionGrid",
  FreeInputAddress = "freeInputAddress",
  YesNoBranchQuestion = "yesNoBranchQuestion",
  Sms = "sms",
}

export enum LyticsProfileVariablesEnum {
  MaritalStatus = "maritalStatus",
  Occupation = "occupation",
  HouseholdIncome = "householdIncome",
  HaveChildren = "haveChildren",
  ChildrenAges = "childrenAges",
  Homeownership = "homeownership",
  ShoppingInterests = "shoppingInterests",
  HavePets = "havePets",
  PetsType = "petsType",
  Ethnicity = "ethnicity",
  PhoneNumber = "phoneNumber",
}

export enum YesNoAnswersTypeEnum {
  YES = "Yes",
  NO = "No",
}

export type LanderQuizQuestionOption = {
  label: string;
  isSelected?: boolean;
};

export type LanderQuizQuestion = {
  title: string;
  type: LanderQuizQuestionTypeEnum;
  options: LanderQuizQuestionOption[] | null;
  lyticsProfileVariable: LyticsProfileVariablesEnum;
  answer?: string | null;
};

export type LanderQuiz = {
  questions: LanderQuizQuestion[];
};

export type LanderQuizFinished = {
  skip_demo_quiz: boolean;
};
